import * as actionTypes from "../actionTypes/Index";
import {zoneInitialState} from "./InitialState";
import {IActionType} from "../../interfaces/Index";

const initialState = { ...zoneInitialState };

export default function zoneReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_CITIES_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isCityListFetched: false,
        citiesList: []
      });
    }
    case actionTypes.GET_CITIES_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        isCityListFetched: true,
        citiesList: (action.payload as any).slice()
      });
    }
    case actionTypes.GET_CITIES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isCityListFetched: false,
        citiesList: []
      });
    }
    default:
      return state;
  }
}
